import React, { useRef, useState, useEffect } from 'react';
import axios from 'axios';
import { CSVLink } from 'react-csv';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { useReactToPrint } from 'react-to-print';

import $ from 'jquery';
import 'datatables.net';
import 'datatables.net-bs4/css/dataTables.bootstrap4.min.css';
import Header from './Header';
import logo from './images/icons/logo.JPG'; // Import your image here
import { Landscape } from '@mui/icons-material';

const ModalViewPlotsCustomersCompletedPayers = () => {
  const server_app_api_php = window.SERVER_APP_API_PHP;

  let business_locationIDMain = localStorage.getItem('business_locationIDMain');

  let userCompanyID = localStorage.getItem('companyID')
  if(userCompanyID === 'Admin'){
   userCompanyID = 1;
  }
  userCompanyID = JSON.parse(userCompanyID)

  let userID = localStorage.getItem('userID')
  if(userID === 'Admin'){
    userID = 1;
  }
  userID = JSON.parse(userID)

  let [businessLocationsPlots, setBusinessLocationsPlots] = useState([]);

 
  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('en-ZM', { style: 'currency', currency: 'ZMW' }).format(amount);
  };

  const formatCurrencyTable = (amount) => {
    // Convert amount to a number if it's not already
    const number = typeof amount === 'number' ? amount : parseFloat(amount);
    return new Intl.NumberFormat('en-ZM', { style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2}).format(number);
  };

    useEffect(() => {
      // Create formData object
      const formData = new FormData();
      formData.append("apiType", 'getBusinessLocationHousesOnUploadForm');
      formData.append("companyID", userCompanyID);
      formData.append("location", '');
      // Fetch plot options from the backend using POST method
      axios.post(`${server_app_api_php}/server/index.php`, formData)
        .then(response => {
          setBusinessLocationsPlots(response.data);
        })
        .catch(error => {
          //alert("There was an error fetching the Business Locations!", error);
        });
      }, []);

  const [dataPlotsCustomers, setDataPlotsCustomers] = useState({
    columns: [
    { label: 'SN', field: 'sn' },
      { label: 'Location', field: 'businessLocationName' },
      { label: 'Old Plot Number', field: 'plotNumber' },
      { label: 'New Plot Number', field: 'plotNumberNew' },
      { label: 'Name', field: 'name' },
      { label: 'Date Contract Signed', field: 'dateContractSigned' },
      { label: 'Last Date Paid', field: 'lastDatePaid' },
      { label: 'Old Plot Price', field: 'plotPrice' },
      { label: 'New Plot Price', field: 'plotPricesNew' },
      { label: 'monthly Pay', field: 'monthlyInstallments' },
      { label: 'Total Paid', field: 'totalAmountPaid' },
      { label: 'Balance', field: 'balance' },
    ],
    rows: [],
  });
  const [totalAmountPlotsCustomers, setTotalAmountPlotsCustomers] = useState(0);
  const [filteredDataPlotsCustomers, setFilteredDataPlotsCustomers] = useState([]);
  const [entriesPlotsCustomers, setEntriesPlotsCustomers] = useState(5); // Number of entries per page
  const [searchValuePlotsCustomers, setSearchValuePlotsCustomers] = useState(''); // Search value
  //const [searchValuePlotsDetailed, setSearchValuePlotsDetailed] = useState('');

  const calculateTotalPlotsCustomers = (rows) => {
    return rows.reduce((sum, row) => sum + parseFloat(row.amountPaid), 0).toFixed(2);
  };

  useEffect(() => {
    const formData = new FormData();
    formData.append('apiType', 'fetchViewPlotsCustomersCompletedPayers');
    formData.append('companyID', userCompanyID);
    formData.append('business_locationIDMain', business_locationIDMain);

    const fetchDataPlotsCustomers = async () => {
      try {
        const response = await axios.post(`${server_app_api_php}/server/index.php`, formData);
        const fetchedData = response.data.map((row, index) => ({
          sn: index + 1,
          businessLocationName: row.businessLocationName,
          plotNumber: row.plotNumber,
          plotNumberNew: row.plotNumberNew,
          name: row.name,
          dateContractSigned: row.dateContractSigned,
          lastDatePaid: row.lastDatePaid,
          plotPrice: row.plotPrice,
          plotPricesNew: row.plotPricesNew,
          monthlyInstallments: row.monthlyInstallments,
          totalAmountPaid: row.totalAmountPaid,
          balance: parseFloat(row.balance),
        }));

        setDataPlotsCustomers((prevState) => ({
          ...prevState,
          rows: fetchedData,
        }));

        setTotalAmountPlotsCustomers(calculateTotalPlotsCustomers(fetchedData));
        setFilteredDataPlotsCustomers(fetchedData); // Initially set all data
      } catch (error) {
        //alert('Internet Error: Failed to fetch data');
      }
    };

    fetchDataPlotsCustomers();
  }, []);

  const handleTableSearch = (value) => {
    setSearchValuePlotsCustomers(value);
    const filteredRows = dataPlotsCustomers.rows.filter((row) => {
      return Object.values(row).some((field) => field.toString().toLowerCase().includes(value.toLowerCase()));
    });
    setFilteredDataPlotsCustomers(filteredRows.slice(0, entriesPlotsCustomers));
  };

  const exportPDFPlotsCustomers = () => {
    const doc = new jsPDF('landscape');
    const pageSize = 100; 
    let pageData = [];

    const searchValueLower = searchValuePlotsCustomers.trim().toLowerCase();

      const filteredByAllFields = searchValueLower === '' ? filteredDataPlotsCustomers : filteredDataPlotsCustomers.filter(row => 
       row.businessLocationName?.toString().toLowerCase().includes(searchValueLower) ||
          row.plotNumber?.toString().toLowerCase().includes(searchValueLower) ||
          row.plotNumberNew?.toString().toLowerCase().includes(searchValueLower) ||
          row.name?.toString().toLowerCase().includes(searchValueLower) ||
          row.dateContractSigned?.toString().toLowerCase().includes(searchValueLower) ||
          row.lastDatePaid?.toString().toLowerCase().includes(searchValueLower) ||
          row.plotPrice?.toString().toLowerCase().includes(searchValueLower) ||
          row.plotPricesNew?.toString().toLowerCase().includes(searchValueLower) ||
          row.monthlyInstallments?.toString().toLowerCase().includes(searchValueLower) ||
          //row.paidToNHEF?.toString().toLowerCase().includes(searchValueLower) ||
          row.totalAmountPaid?.toString().toLowerCase().includes(searchValueLower) ||
          row.balance?.toString().toLowerCase().includes(searchValueLower)
      );
      
    //for (let i = 0; i < filteredData.length; i += pageSize) {
      //pageData = filteredData.slice(i, i + pageSize);
      
      //for (let i = 0; i < filteredByAllFields.length; i += pageSize) {
      //pageData = filteredByAllFields.slice(i, i + pageSize);
      // Assuming calculateTotal is a function that takes an array of data and returns the total of the amountPaid field
const calculateTotalPlotsCustomers = (data) => {
  return data.reduce((total, row) => total + parseFloat(row.totalAmountPaid), 0);
};

 pageData = filteredByAllFields;

const calculatePageTotalPlotsCustomers = (rows) => {
  return rows.reduce((total, row) => total + parseFloat(row.raw[8]), 0).toFixed(2);
};

const addPageTotalPlotsCustomers = (data) => {
  let pageTotal = calculatePageTotalPlotsCustomers(data.table.body);
  doc.text(`Total: K ${pageTotal}`, data.settings.margin.left + 350, doc.internal.pageSize.height - 10);
};

doc.autoTable({
  head: [['SN', 'Location', 'Old Plot#', 'New Plot#', 'Name', 'Date Contract Signed', 'Last Date Paid', 'Old Plot Price (ZMW)', 
    'New Plot Price (ZMW)','Monthly Pay (ZMW)',  'Total Amount Paid (ZMW)', 'Balance (ZMW)']],
  body: pageData.map((row, index) => [
    index + 1,
    row.businessLocationName,
    row.plotNumber,
    row.plotNumberNew,
    row.name,
    row.dateContractSigned,
    row.lastDatePaid,
    formatCurrencyTable(row.plotPrice),
    formatCurrencyTable(row.plotPricesNew),
    formatCurrencyTable(row.monthlyInstallments),
    //formatCurrencyTable(row.paidToNHEF),
    formatCurrencyTable(row.totalAmountPaid),
    formatCurrencyTable(row.balance)
  ]),
  didDrawPage: addPageTotalPlotsCustomers,
  margin: { bottom: 20 } // Adjust bottom margin to make space for the total text
});

const overallTotal = calculateTotalPlotsCustomers(filteredByAllFields).toFixed(2);
doc.autoTable({
  head: [['', '', '', '', '', '', '']],
  foot: [['', '', '', 'Total Amount Paid:', formatCurrency(overallTotal)+"(ZMW)", '', '']],
  startY: doc.lastAutoTable.finalY + 10 // Start a bit after the last table
});


    doc.save('plots Late Payers customers statement.pdf');
  };

  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    onBeforeGetContent: () => {
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve();
        }, 500);
      });
    },
  });
  
  /**********Codes for DataTables Starts Here************/   
  const [DBtablePlotsCustomers, setDBtablePlotsCustomers] = useState([]);
  //const [pdfData, setPdfData] = useState([]);
  const [entriesValuePlotsCustomers, setEntriesValuePlotsCustomers] = useState(5);
  useEffect(() => {
    fetchDataForTablePlotsCustomers();
  }, [entriesValuePlotsCustomers]);

  const fetchDataForTablePlotsCustomers = async () => {
    const formData = new FormData();
    formData.append('apiType', 'fetchViewPlotsCustomersCompletedPayers');
    formData.append('companyID', userCompanyID);
    formData.append('business_locationIDMain', business_locationIDMain);
    try {
      const response = await axios.post(`${server_app_api_php}/server/index.php`, formData);
      //alert('API Response Data for Table: ' + JSON.stringify(response.data));

      const processedData = response.data.map(row => ({
        ...row,
        amountPaid: parseFloat(row.amountPaid) || 0
      }));

      setDBtablePlotsCustomers(processedData);
      //alert('Processed Data for Table: ' + JSON.stringify(processedData));

      setTimeout(() => {
        const table = $('#tablePlotsCustomers').DataTable({
          footerCallback: function (row, data, start, end, display) {
            const api = this.api();

            const pageTotal = api
              .column(9, { page: 'current' })
              .data()
              .reduce((a, b) => a + (parseFloat(b) || 0), 0);

            //alert('Page Total: ' + pageTotal);

            $(api.column(9).footer()).html(pageTotal.toFixed(2));

            const overallTotal = api
              .column(9)
              .data()
              .reduce((a, b) => a + (parseFloat(b) || 0), 0);

            //alert('Overall Total: ' + overallTotal);

            $('#totalOverallPlotsCustomers').html(overallTotal.toFixed(2));
          },
          retrieve: true,
          pageLength: entriesValuePlotsCustomers,
          lengthMenu: [5, 10, 25, 50, 100, 200, 500, 1000, 2000, 5000, 10000, 15000, 20000, 50000, 100000, 500000, 1000000],
          initComplete: function () {
            const api = this.api();
            setSearchValuePlotsCustomers(api.search());
            setEntriesValuePlotsCustomers(api.page.len());

            api.on('search.dt', function () {
              setSearchValuePlotsCustomers(api.search());
            });

            api.on('length.dt', function () {
              setEntriesValuePlotsCustomers(api.page.len());
            });
          }
        });

        //addTableButtons(table);
      }, 1000);
    } catch (error) {
     // alert('Error fetching data for table: ' + error);
    }
  };
  /**********Codes For DataTables Ends Here****************/


  const [customerStatement, setCustomerStatement] = useState([{ loopedItems: [], nonLoopedItems: {} }]);
  /**************Function To Respond To View Statement From The Main Table Starts Here***********************/
  const viewPlotsCustomers = customerID => {
    // Assuming responseData is an array of objects
    const loopedItems = customerID.map(item => item.loopedItems).flat() || [];
    const nonLoopedItems = customerID.map(item => item.nonLoopedItems) || [];
    setCustomerStatement({ loopedItems, nonLoopedItems });
    }
  /**************Function To Respond To View Statement From The Main Table Ends Here***********************/
 
const sendEmailPlotsLoginCredentials = id => {
      // Create FormData to send to the server
      const formData = new FormData();
      formData.append('apiType', 'sendEmailPlotsLoginCredentials');
      formData.append('id', id);    
      axios.post(`${server_app_api_php}/server/index.php`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
      .then(response => {
        alert(response.data);
      })
      .catch(error => {
        alert('Error sending Loggin Credentials');
      });

  }
 
  const comfirmCustomersAvailability = id => {
    // Create FormData to send to the server
    const formData = new FormData();
    formData.append('apiType', 'comfirmClientAvailability');
    formData.append('customerID', id);
    formData.append('customerType', 'Plots');
    axios.post(`${server_app_api_php}/server/payment_remindersEmailList.php`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
    .then(response => {
      alert(response.data);
    })
    .catch(error => {
      alert('Error sending Comfirmation');
    });  
}

const { loopedItems, nonLoopedItems } = customerStatement;

// Ensure nonLoopedItems is defined and is an array
const groupByPlotNumber = (items) => {
  if (!Array.isArray(items)) {
    return {}; // Return an empty object if items is not an array
  }
  return items.reduce((acc, item) => {
    const { plotNumber } = item;
    if (!acc[plotNumber]) {
      acc[plotNumber] = [];
    }
    acc[plotNumber].push(item);
    return acc;
  }, {});
};
// Safely access nonLoopedItems
const groupedItems = groupByPlotNumber(nonLoopedItems || []);

const[customersEmail, setCustomersEmail] = useState('');
/**************** Plots Customers PDF Generating Function Code Starts Here ******************/
const generatePDFPlotCustomerStatement = (nonLoopedItems, groupedItems, logo, loopedItems, action) => {
  const nonLoopedItem = nonLoopedItems[0];
  setCustomersEmail(nonLoopedItem.customersEmail);
  //alert(action);
  const doc = new jsPDF('landscape'); // Create PDF in landscape orientation
  const pageWidth = doc.internal.pageSize.getWidth();
  const pageHeight = doc.internal.pageSize.getHeight();
  
  // Add logo
  if (logo) {
    const img = new Image();
    img.src = logo;
    doc.addImage(img, 'PNG', 135, 7, 30, 15); // Position the image in the center
  }
  
  // Title with styling
  doc.setFontSize(18);
  doc.setTextColor(0, 0, 0); // Black text
  doc.text('Customer Statement', pageWidth / 2, 30, { align: 'center' });
  
  // Customer Details section with background color and text color
  doc.setFillColor(0, 105, 148); // Deep Ocean Blue
  doc.rect(10, 40, 270, 20, 'F'); // Filled rectangle for background
  
  doc.setFontSize(12);
  doc.setTextColor(255, 255, 255); // White text
  if (Array.isArray(nonLoopedItems) && nonLoopedItems.length > 0) {
    doc.text(`Name: ${nonLoopedItems[0]?.name || '-'}`, 12, 50);
    doc.text(`Phone: ${nonLoopedItems[0]?.customersPhone || '-'}`, 100, 50);
    doc.text(`Email: ${nonLoopedItems[0]?.customersEmail || '-'}`, 170, 50);
  } else {
    doc.text('No items available.', 12, 50);
  }
  
  // Add a line break
  doc.setLineWidth(0.5);
  doc.line(10, 65, 280, 65); // Horizontal line
  
  // Grouped Items
  let startY = 75;
  const marginBottom = 20; // Space at the bottom of the page
  
  Object.keys(groupedItems).forEach((plotNumber, index) => {
    const item = groupedItems[plotNumber][0];
    let blockHeight = 75;
    if (item?.paidToNHEF) { 
     blockHeight = 65; // Approximate height needed for each block of content
    }
    else{
       blockHeight = 65; // Approximate height needed for each block of content
    }
    // Check if the current block will overflow the page
    if (startY + blockHeight > pageHeight - marginBottom) {
      doc.addPage(); // Add a new page if needed
      startY = 20; // Reset the starting Y position for the new page
    }
  
    // Background for each group
    doc.setFillColor(0, 105, 148); // Deep Ocean Blue
    doc.rect(10, startY, 270, blockHeight - 10, 'F'); // Filled rectangle for background
  
    doc.setFontSize(12);
    doc.setTextColor(255, 255, 255); // White text
    doc.text(`Location: ${item?.businessLocationName || '-'}`, 12, startY + 10);
    doc.text(`Old Plot Number: ${plotNumber || '-'}`, 12, startY + 20);
    doc.text(`New Plot Number: ${item?.plotNumberNew || '-'}`, 12, startY + 30);
    doc.text(`Old Plot Area: ${item?.plotArea + " (M2)" || '-'}`, 12, startY + 40);
    doc.text(`New Plot Area: ${item?.plotArea + " (M2)" || '-'}`, 12, startY + 50);
    doc.text(`Amount Contributed: ${formatCurrency(item?.totalAmountPaid) + " (ZMW)" || '-'}`, 12, startY + 60);
    if (item?.paidToNHEF) {      
      //doc.text(`Paid To NHEF: ${formatCurrency(item?.paidToNHEF) + " (ZMW)" || '-'}`, 12, startY + 50);
      doc.text(`Total Contributions: ${formatCurrency(item?.totalContributions) + " (ZMW)" || '-'}`, 12, startY + 70);
    }
    else{
      doc.text(`Total Contributions: ${formatCurrency(item?.totalContributions) + " (ZMW)" || '-'}`, 12, startY + 70);
    }
  
    
    doc.text(`Old Plot Price: ${formatCurrency(item?.plotPrice) + " (ZMW)" || '-'}`, 180, startY + 10);
    doc.text(`New Plot Price: ${formatCurrency(item?.plotPrice) + " (ZMW)" || '-'}`, 180, startY + 20);
    doc.text(`Balance: ${formatCurrency(item?.balance) + " (ZMW)" || '-'}`, 180, startY + 30);
    doc.text(`Monthly Installments: ${formatCurrency(item?.monthlyInstallments) + " (ZMW)" || '-'}`, 180, startY + 40);
    doc.text(`Last Date Paid: ${item?.lastDatePaid || '-'}`, 180, startY + 50);
    doc.text(`Date Contract Signed: ${item?.dateContractSigned || '-'}`, 180, startY + 60);
  
    // Update the startY for the next block of content
    startY += blockHeight;
  });
  
  // Add space before the table
  startY += 20;
  
  // Check if the table will fit on the remaining space of the page
  if (startY + 20 > pageHeight - marginBottom) {
    doc.addPage(); // Add a new page if needed
    startY = 20;
  }
  
  // Table content
  const tableData = loopedItems.map((val, index) => [
    index + 1,
    val.plotNumber,
    val.plotNumberNew,
    formatCurrencyTable(val.amountPaid),
    val.datePaid,
  ]);
  
  // Generate the table
  doc.autoTable({
    startY, // Start position of the table
    head: [['SN', 'Old Plot Number', 'New Plot Number', 'Amount (ZMW)', 'Date']],
    body: tableData,
    theme: 'striped',
    headStyles: {
      fillColor: [0, 128, 255], // Ocean blue gradient for header
      textColor: [255, 255, 255], // White text
    },
    styles: {
      cellPadding: 3,
      fontSize: 10,
    },
  });
  
  // Add page numbers before saving
  addPageNumber(doc);
  
  // Save the PDF
  //doc.save('CustomerStatement.pdf');
  

  if (action === "Download") {
    //doc.save('Customer Statement.pdf');
    doc.save(`Customer Statement -  ${nonLoopedItems[0]?.name}.pdf`);
  } 
  else if (action === "Email") {
// Return the PDF as a Blob
  //return doc.output('blob');
  // Convert PDF to Blob
  const pdfOutput = doc.output('blob');
    
  // Create FormData to send to the server
  const formData = new FormData();
  formData.append('file', pdfOutput, `Customer Statement -  ${nonLoopedItems[0]?.name}.pdf`);
  formData.append('apiType', 'sendEmailCustomerStatementPDF');
  formData.append('email', customersEmail);

  // Send the PDF to your server
  axios.post(`${server_app_api_php}/server/index.php`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
  .then(response => {
    alert('Email sent successfully', response.data);
  })
  .catch(error => {
    alert('Error sending email', error);
  });
  }
};
// Function to add page numbers
const addPageNumber = (doc) => {
  const pageCount = doc.internal.getNumberOfPages();
  for (let i = 1; i <= pageCount; i++) {
    doc.setPage(i);
    doc.setFontSize(10);
    doc.setTextColor(128, 128, 128); // Gray text
    doc.text(`Page ${i} of ${pageCount}`, doc.internal.pageSize.getWidth() - 20, doc.internal.pageSize.getHeight() - 10, { align: 'right' });
  }
};
/******************* Plots Customers PDF Generating Function Code Starts Here ******************************/

 /**************Function To Respond To Generate PDF From The Main Table Starts Here***********************/
 const viewPlotsCustomersFromTheMainTablePdf = (customerID, action) => {
  // Assuming responseData is an array of objects
  const loopedItems = customerID.map(item => item.loopedItems).flat() || [];
  const nonLoopedItems = customerID.map(item => item.nonLoopedItems) || [];
  setCustomerStatement({ loopedItems, nonLoopedItems });  
  // Safely access nonLoopedItems
const groupedItems = groupByPlotNumber(nonLoopedItems || []);
generatePDFPlotCustomerStatement(nonLoopedItems, groupedItems, logo, loopedItems, action);
  }
/**************Function To Respond To Generate PDF From The Main Table Ends Here***********************/
// Ensure nonLoopedItems is defined and is an array

return (
    <>
     <Header />
    
   <main class="bg-white">   
   <hr />
    <div className="container-fluid mt-5" style={{ overflowX: 'auto' }}>

    {/**************Modal For Plot Customer Statement Starts Here****************/}
    <div className="modal fade" id="modalViewPlotsCustomers" tabIndex="-1" role="dialog" aria-labelledby="myModalLabel"
          aria-hidden="true">
          <div className="modal-dialog modal-fluid modal-notify modal-success" role="document">
            {/* Content */}
            <div className="modal-content">
              {/* Header */}
              <div className="modal-header">
                <p className="heading lead">View Plot Customer Details</p>

                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true" className="white-text">&times;</span>
                </button>
              </div>

              {/* Body */}
              <div className="modal-body ">
               
			    {/* Second column */}
          <div className="col-md-12 col-lg-12 col-xl-12 mb-md-0 mb-5 ">

            {/* Card */}
            <div className="card profile-card ">


              <div className="card-body pt-0 mt-0">                				
                        
              <div className='mt-5'>
                <div className='row'>
                <div className='col-md-6 text-left'>
              <a type="button" className="btn btn-outline-success waves-effect"
              onClick={() => {
                generatePDFPlotCustomerStatement(nonLoopedItems, groupedItems, logo, loopedItems, 'Email')
              }}
              >Send Email</a>
              </div>
              <div className='col-md-6 text-right'>
              <a type="button" className="btn btn-outline-success waves-effect" onClick={() => {
              generatePDFPlotCustomerStatement(nonLoopedItems, groupedItems, logo, loopedItems, 'Download')
              }}>PDF</a>
              </div>
              </div>

              <div className='text-center'>
          <img src={logo} alt="Logo" style={{ width: '120px', height: '60px' }} />
          <h1 className='font-weight-bold text-uppercase'>Customer Statement</h1>
        </div>
                <hr />
                
        <div className='row py-3 morpheus-den-gradient accent-2 white-text'>
        {Array.isArray(nonLoopedItems) && nonLoopedItems.length > 0 && (
          <>
        <div className='col-md-5 text-left'>         
        <span className='font-weight-bold text-uppercase'>Name:</span> {nonLoopedItems[0]?.name || '-'}                             
          </div>
          <div className='col-md-2 text-left'>
          <span className='font-weight-bold text-uppercase'>Phone:</span> {nonLoopedItems[0]?.customersPhone || '-'} 
          </div>
          <div className='col-md-5 text-left'>
          <span className='font-weight-bold text-uppercase'>Email:</span> {nonLoopedItems[0]?.customersEmail || '-'}
        </div>
        </>
      )}
      {Array.isArray(nonLoopedItems) && nonLoopedItems.length === 0 && <p>No items available.</p>}
        </div>
                <hr />
                        {/* Display only the first non-looped item */}
                        {Array.isArray(nonLoopedItems) && nonLoopedItems.length > 0 && (
                          <>
                          {Object.keys(groupedItems).map((plotNumber, index) => (
                            <>
                           <div key={index} className="row morpheus-den-gradient accent-2 white-text mt-5 mb-5 p-2">
        <div className="col-md-6 text-left">
          <p>
            <span className="font-weight-bold text-uppercase">
              Location:
            </span>{" "}
            {groupedItems[plotNumber][0]?.businessLocationName || "-"}
          </p>
          <p>
            <span className="font-weight-bold text-uppercase">
              Old Plot Number:
            </span>{" "}
            {plotNumber || "-"}
          </p>
          <p>
            <span className="font-weight-bold text-uppercase">
              New Plot Number:
            </span>{" "}
            {groupedItems[plotNumber][0]?.plotNumberNew || "-"}
          </p>
          <p>
            <span className="font-weight-bold text-uppercase">
              Old Plot Area:
            </span>{" "}
            {groupedItems[plotNumber][0]?.plotArea + " (M2)" || "-"}
          </p>
          <p>
            <span className="font-weight-bold text-uppercase">
             New Plot Area:
            </span>{" "}
            {groupedItems[plotNumber][0]?.plotAreasNew + " (M2)" || "-"}
          </p>
          <p>
            <span className="font-weight-bold text-uppercase">
              Amount Contributed:
            </span>{" "}
            {formatCurrency(
              groupedItems[plotNumber][0]?.totalAmountPaid
            ) + " (ZMW)" || "-"}
          </p>
         
          <p hidden >
            <span className="font-weight-bold text-uppercase">
            Paid To NHEF:
            </span>{" "}
            {formatCurrency(groupedItems[plotNumber][0]?.paidToNHEF) +
              " (ZMW)" || "-"}
          </p>

          <p>
            <span className="font-weight-bold text-uppercase">
            Total Contributions:
            </span>{" "}
            {formatCurrency(groupedItems[plotNumber][0]?.totalContributions) +
              " (ZMW)" || "-"}
          </p>

        </div>
        <div className="col-md-6 text-left">
          <p>
            <span className="font-weight-bold text-uppercase">
              Old Plot Price:
            </span>{" "}
            {formatCurrency(groupedItems[plotNumber][0]?.plotPrice) +
              " (ZMW)" || "-"}
          </p> 
          <p>
            <span className="font-weight-bold text-uppercase">
              New Plot Price:
            </span>{" "}
            {formatCurrency(groupedItems[plotNumber][0]?.plotPricesNew) +
              " (ZMW)" || "-"}
          </p>          
          <p>
            <span className="font-weight-bold text-uppercase">Balance:</span>{" "}
            {formatCurrency(groupedItems[plotNumber][0]?.balance) + " (ZMW)" || "-"}
          </p>
          <p>
          <p>
            <span className="font-weight-bold text-uppercase">
              Monthly Installments:
            </span>{" "}
            {formatCurrency(
              groupedItems[plotNumber][0]?.monthlyInstallments
            ) + " (ZMW)" || "-"}
          </p>
            <span className="font-weight-bold text-uppercase">
              Last Date Paid:
            </span>{" "}
            {groupedItems[plotNumber][0]?.lastDatePaid || "-"}
          </p>
          <p>
            <span className="font-weight-bold text-uppercase">
              Date Contract Signed:
            </span>{" "}
            {groupedItems[plotNumber][0]?.dateContractSigned || "-"}
          </p>
        </div>
      </div>

      <hr className='my-5'/>
                            </>
                          ))}
                          </>
                        )}
                        {Array.isArray(nonLoopedItems) && nonLoopedItems.length === 0 && <p>No items available.</p>}
                    </div>

             
				<div className="row">
				
<table id="tableViewPlotsCustomers"  className="table table-striped table-bordered table-hover table-sm ">
	<thead className="ocean blue-gradient white-text">
                    <tr>
  <th className="font-weight-bold "><strong>SN</strong></th>
  <th className="font-weight-bold "><strong>Old Plot Number</strong></th>
  <th className="font-weight-bold "><strong>New Plot Number</strong></th>
  <th className="font-weight-bold "><strong>Amount (ZMW)</strong></th>
  <th className="font-weight-bold "><strong>Date</strong></th>
                    </tr>
                  </thead>
	
	<tbody>
  {loopedItems ? (
                            <>
  {loopedItems.map((val, index) => (
                          <tr key={index}>
                            <td>{index + 1}</td>
                            <td>{val.plotNumber}</td>
                            <td>{val.plotNumberNew}</td>
                            <td>{formatCurrencyTable(val.amountPaid)}</td>
                            <td>{val.datePaid}</td>
                            </tr>

                          ))}

</>
                        ) : (
                            <p>Loading  items...</p>
                        )}
    
	</tbody>
	
	<tfoot className='form-header text-center black-text'>
                       
                      </tfoot>
					  
	</table>
	
</div>
				
			</div>

            </div>
            {/* Card */}

          </div>
          {/* Second column */}
			   
              </div>

              {/* Footer */}
              <div className="modal-footer">
                <div className='row'>
                  <div className='col-md-6 left'>
                  <a type="button" className="btn btn-outline-success waves-effect" onClick={() => {
                generatePDFPlotCustomerStatement(nonLoopedItems, groupedItems, logo, loopedItems, 'Download')
              }}>PDF</a>
                  </div>
                  <div className='col-md-6 text-right'>
                  <a type="button" className="btn btn-outline-success waves-effect" data-dismiss="modal">Close</a>
                  </div>
                </div>
              </div>
            </div>
            {/* Content */}
          </div>
        </div>

    {/**************Modal For Plot Customer Statement Ends Here *****************/}
  
<div class="view view-cascade gradient-card-header  ocean blue-gradient">
                  <h2 class="h2-responsive mb-0 font-weight-bold white-text py-5">RIDGEHILL REAL ESTATE</h2>
                </div>      
     
      <section className="fixed-sn white-skin">
          <div className="d-flex justify-content-center align-items-center">
            <div className="">
              <div className="card mt-5">
                <div className="card-body">
                  <div className="">
                    <br />
                    <h2 className="form-header white-text ocean blue-gradient text-uppercase">View Plots Customers Details - Completed Payments</h2>

                    <center>
                    <div id="filterTopCriteria">
                    <button onClick={exportPDFPlotsCustomers} className="btn btn-primary me-2">PDF</button>
                      </div>
                    </center>
                    <table id="tablePlotsCustomers" className="table table-striped table-bordered table-hover table-sm">
                      <thead className="form-header text-uppercase ocean blue-gradient">
                        <tr>
                    <th>S/N</th>
                    <th><strong>Location</strong></th>
                      <th><strong>Old Plot#</strong></th>
                      <th><strong>New Plot#</strong></th>
                      <th><strong>Name</strong></th>
                      <th><strong>Date Contract Signed</strong></th>
                      <th><strong>Last Date Paid</strong></th>
                      <th><strong>Old Plot Price</strong></th>
                      <th><strong>New Plot Price</strong></th>
                      <th><strong>Total</strong></th>
                      <th><strong>Balance</strong></th>
                      <th><strong>Action</strong></th>
                        </tr>
                      </thead>
                      <tbody>
                        {DBtablePlotsCustomers.map((val, index) => (
                          <tr key={index}>
                            <td>{index + 1}</td>
                            <td>{val.businessLocationName}</td>
                            <td>{val.plotNumber}</td>
                            <td>{val.plotNumberNew}</td>
                            <td>{val.name}</td>
                            <td>{val.dateContractSigned}</td>
                            <td>{val.lastDatePaid}</td>
                            <td>{val.plotPrice}</td>
                            <td>{val.plotPricesNew}</td>
                            <td>{val.totalAmountPaid}</td>
                            <td>{val.balance.toFixed(2)}</td>
                            <td>
                            <ul class="nav navbar-nav nav-flex-icons ml-auto" >
	  <li class="nav-item dropdown">
            <a class="nav-link dropdown-toggle waves-effect" href="" id="userDropdown" data-toggle="dropdown"
              aria-haspopup="true" aria-expanded="false">
              <span class="clearfix d-none d-sm-inline-block"></span>
            </a>
            <div class="dropdown-menu dropdown-menu-right" aria-labelledby="userDropdown" style={{width: '500%' }}>
			
<a class="dropdown-item"
    data-toggle='modal'
    data-target='#modalViewPlotsCustomers'
    onClick={() => {
      viewPlotsCustomers(val.customerStatement)
    }}
><span class = "fa fa-envelope"></span>View Statement</a>
<a class="dropdown-item"
    onClick={() => {
      viewPlotsCustomersFromTheMainTablePdf(val.customerStatement, 'Email')
    }}
><span class = "fa fa-eye"></span>Send Statement To Email</a>
<a class="dropdown-item"
    onClick={() => {
      viewPlotsCustomersFromTheMainTablePdf(val.customerStatement, 'Download')
    }}
><span class = "fa fa-eye"></span>PDF Customer Statement</a>
<a class="dropdown-item"
onClick={() => {
  comfirmCustomersAvailability(val.customersID)
}}
><span class = "fa fa-check"></span>Confirm For Automated Payment Reminder</a>
<a class="dropdown-item"
onClick={() => {
  sendEmailPlotsLoginCredentials(val.customersID)
}}
><span class = "fa fa-envelope"></span>Send Login Credentials</a>			 

           </div>
          </li></ul>

                            </td>
                          </tr>
                        ))}
                      </tbody>
                      <tfoot className="form-header text-center ocean blue-gradient">
                        <tr>
                          <th></th>
                          <th></th>
                          <th></th>
                          <th></th>
                          <th></th>
                          <th></th>
                          <th></th>
                          <th></th>
                          <th>TOTAL PAID</th>
                          <th></th>
                          <th></th>
                          <th></th>
                        </tr>
                        <tr>
                        <th></th>
                        <th></th>
                          <th></th>
                          <th></th>
                          <th></th>
                          <th></th>
                          <th></th>
                          <th></th>
                          <th>
                            <div className="text-white text-uppercase">
                              <span>Over Total Amount Paid</span>
                            </div>
                          </th>
                          <th>
                          <div className="text-white">
                              <span id="totalOverallPlotsCustomers"></span>
                            </div>
                          </th>
                          <th></th>
                          <th></th>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      <div hidden>
      <div className="d-flex justify-content-between align-items-center mb-4">
        <div>
          <CSVLink
            data={filteredDataPlotsCustomers}
            headers={dataPlotsCustomers.columns.map((col) => ({ label: col.label, key: col.field }))}
            filename="plots_Customers.csv"
            className="btn btn-primary me-2"

            hidden
          >
            CSV
          </CSVLink>
          <button onClick={exportPDFPlotsCustomers} className="btn btn-primary me-2">PDF</button>
          <button hidden onClick={handlePrint} className="btn btn-primary">Print</button>
        </div>
        <div className="d-flex align-items-center">
          <label htmlFor="entriesSelect" className="me-2">Show entries:</label>
          <select
            id="entriesSelect"
            value={entriesPlotsCustomers}
            onChange={(e) => setEntriesPlotsCustomers(Number(e.target.value))}
            className="form-select me-3"
            style={{ width: '75px' }}
          >
            <option value={5}>5</option>
            <option value={10}>10</option>
            <option value={15}>15</option>
            <option value={20}>20</option>
          </select>
          <input
            type="text"
            placeholder="Search..."
            value={searchValuePlotsCustomers}
            onChange={(e) => handleTableSearch(e.target.value)}
            className="form-control"
            style={{ width: '200px' }}
          />
        </div>
      </div>
      </div>
      <hr />
    </div>
    </main>

    </>
  );
};

export default ModalViewPlotsCustomersCompletedPayers;
